export enum HISTORY_LABEL {
  EDIT = "Bearbeiten",
  ABORT = "Abbrechen",
  DELETE_SELECTED = "Auswahl löschen",
  DELETE_ALL = "Alle löschen",
}

export const PLACEHOLDER: string = "BELIEBTE SUCHEN";
